import Blockchains from '@depay/web3-blockchains'
import { Currency } from '@depay/local-currency'
import DePayWidgets from '@depay/widgets'
import { wallets } from '@depay/web3-wallets'
import React, { useState, useEffect } from 'react'

export default function(props) {

  const [ error, setError ] = useState( !!props.errorText || !props.accept )
  const [ succeeded, setSucceeded ] = useState(false)
  const [ worldAppWalletAddress, setWorldAppWalletAddress ] = useState(new wallets.WorldApp().walletAddress())

  const startEruda = ()=>{
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/eruda';
    script.onload = function() {
      // Initialize Eruda once the script is loaded
      window.eruda.init();
      console.log('Eruda has been initialized.');
    };
    document.body.appendChild(script);
  }

  const openPaymentWidget = async()=> {
    if(error){ return }
    if(window.WorldApp && !worldAppWalletAddress) { return }
    let { unmount } = await DePayWidgets.Payment({ 
      style: {
        colors: {
          primary: props.color || '#EA357A'
        }
      },
      accept: props.accept,
      before: async()=>{
        if(props.test) {
          if(unmount) { unmount() }
          await fetch(`${window.location.pathname}/test`, {
            method: 'POST',
            headers: { "Content-Type": "application/json", "X-CSRF-TOKEN": document.querySelector('[name=csrf-token]').content }
          })
          .then(response => response.json()) // Assuming the server responds with JSON
          .then(data => {
              if (data.redirect) {
                window.location.href = data.redirect
              } else {
                console.error('No redirect URL provided')
              }
          }).catch(error => console.error('Error:', error))
          return false
        }
        
      },
      connected: props.connected,
      wallets: props.wallets,
      whitelist: props.whitelist,
      succeeded: ()=>{ setSucceeded(true) },
      track: {
        method: async(payment)=>{
          let response = await fetch(`${window.location.pathname}/track`, {
            method: 'POST',
            body: JSON.stringify(payment),
            headers: { "Content-Type": "application/json", "X-CSRF-TOKEN": document.querySelector('[name=csrf-token]').content }
          })
          if(response.status != 200) { throw 'TRACKING FAILED' }
        },
        poll: {
          method: async (payment)=>{
            let response = await fetch(`${window.location.pathname}/release`, {
              method: 'POST',
              body: JSON.stringify(payment),
              headers: { "Content-Type": "application/json", "X-CSRF-TOKEN": document.querySelector('[name=csrf-token]').content }
            })
            if(response.status == 200) {
              let json = await response.json()
              return json
            }
          },
        }
      }
    })
  }

  useEffect(()=>{
    openPaymentWidget()
  }, [])

  if(error) {
    return(
      <div id='payment'>
        <div className='d-flex position-fixed min-vh-100 w-100' style={{ height: '300vh', top: '-100vh' }}>
          <div className='col-12 col-md-6' style={{ backgroundColor: props.color }}></div>
          <div className='col-12 col-md-6'></div>
        </div>
        <div className='light' style={{ position: 'fixed', top: '-10vh', background: 'radial-gradient(50% 50% at 50% 10%, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0) 100%)' }}></div>
        <div className='position-relative'>
          <div className='d-flex min-vh-100 align-items-center'>
            <div className='w-100 pt-4 pb-0 pb-md-5' style={{ minHeight: '600px' }}>
              <div className='d-inline-block w-100 h-100'>
                <div className='row'>
                  <div className='col-12 col-md-6'>
                    <div className='d-flex justify-content-end h-100 px-4 px-md-0 pb-4 pb-md-0'>
                      <div className='container row pe-0 pe-md-5 justify-content-end'>
                        <div className='col-5 pt-4 d-flex flex-column payment-link-column left h-100'>
                          <div className='pt-3 pt-md-1 pb-1 fs-1 mb-0 opacity-50' style={{ color: props.text, minHeight: '25vh' }}>
                            <i className="fas fa-exclamation-triangle"></i>
                          </div>
                          <div className='align-self-end w-100 d-none d-md-block pt-6'>
                            <div className='opacity-50' style={{ color: props.text }}>
                              <div className='d-block d-md-inline-block me-3'>
                                <small><span>Powered by</span><strong className='ms-1'><a href='https://depay.com' style={{ color: props.text }} target='_blank' title='DePay'>DePay</a></strong>
                                </small>
                              </div>
                              <div className='d-block d-md-inline-block'>
                                <a className='me-2' href='https://depay.com/web3-payments' style={{ color: props.text }} target='_blank'><small>Web3 Payments</small></a>
                                <a className='ms-1 me-2' href='https://depay.com/legal/terms' style={{ color: props.text }} target='_blank'><small>Terms</small></a>
                                <a className='ms-1 me-2' href='https://depay.com/privacy' style={{ color: props.text }} target='_blank'><small>Privacy</small></a>
                                <a className='ms-1 me-2' href='mailto:support@depay.com?subject=Problem with Shopify Payment 9788a65f-ba03-4fed-812e-d442ad928d9a' style={{ color: props.text }} target='_blank'><small>Help</small></a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-md-6 ps-0 ps-md-5'>
                    <div className='container row pe-0 pe-md-5'>
                      <div className='col-5 payment-link-column right px-4 px-md-0 bg-grey pb-0 pt-4 pt-md-0'>
                        <div className='flex-grow-1 pt-3' style={{ minHeight: '45vh' }}>
                          <h2 className='h5 mb-2'>{ props.errorText || "Payment failed!" }</h2>
                          <div>
                            <span>Please </span>
                            <button className="link" onClick={ ()=>window.location.reload(true) }><strong>try again</strong></button>.
                            <br/>
                            <div className="pt-2">
                              <a className="link" href={`mailto:support@depay.com?subject=Problem with Shopify Payment ${window.location.pathname.split('/')[3]}`}><strong>Report a problem</strong></a>
                              <span> if this keeps happening.</span>
                            </div>
                          </div>
                        </div>
                        <div className='align-self-end w-100 d-block d-md-none pt-5 pb-3 text-center pt-6'>
                          <div className='opacity-50'>
                            <div className='d-block d-md-inline-block me-3'>
                              <small><span>Powered by</span><strong className='ms-1'><a className='text-black' href='https://depay.com' target='_blank' title='DePay'>DePay</a></strong></small>
                            </div>
                            <div className='d-block d-md-inline-block'>
                              <a className='me-2 text-black' href='https://depay.com/web3-payments' target='_blank'>
                              <small>
                              Web3 Payments
                              </small>
                              </a>
                              <a className='ms-1 me-2 text-black' href='https://depay.com/legal/terms' target='_blank'>
                              <small>
                              Terms
                              </small>
                              </a>
                              <a className='ms-1 me-2 text-black' href='https://depay.com/privacy' target='_blank'>
                              <small>
                              Privacy
                              </small>
                              </a><a className='ms-1 me-2 text-black' href='mailto:support@depay.com?subject=Problem with Shopify Payment 9788a65f-ba03-4fed-812e-d442ad928d9a' target='_blank'><small>Help</small></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  } else if(succeeded) {
    return(null)
  } else {
    return(
      <div id='payment'>
        <div className='d-flex position-fixed min-vh-100 w-100' style={{ height: '300vh', top: '-100vh' }}>
          <div className='col-12 col-md-6' style={{ backgroundColor: props.color }}></div>
          <div className='col-12 col-md-6'></div>
        </div>
        <div className='light' style={{ position: 'fixed', top: '-10vh', background: 'radial-gradient(50% 50% at 50% 10%, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0) 100%)' }}></div>
        <div className='position-relative'>
          <div className='d-flex min-vh-100 align-items-center'>
            <div className='w-100 pt-4 pb-0 pb-md-5' style={{ minHeight: '600px' }}>
              <div className='d-inline-block w-100 h-100'>
                <div className='row'>
                  <div className='col-12 col-md-6'>
                    <div className='d-flex justify-content-end h-100 px-4 px-md-0 pb-4 pb-md-0'>
                      <div className='container row pe-0 pe-md-5 justify-content-end'>
                        <div className='col-5 pt-4 d-flex flex-column payment-link-column left h-100'>
                          <div className='pt-3 pt-md-1 pb-1 fs-1 mb-0' style={{ color: props.text, minHeight: '25vh' }}>
                            <div className="d-flex pt-3 align-items-center pb-2">
                              <div className="pe-3 position-relative">

                                { props.backUrl &&
                                  <a title="go back" className="back-button" href={ props.backUrl }>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.45 20"><path fill={props.text} d="M22.45,8H6.8l4.62-4.62c.39-.39.58-.86.58-1.38,0-.98-.81-2-2-2-.53,0-.99.19-1.38.58L.66,8.54c-.33.33-.66.73-.66,1.46s.28,1.08.65,1.45l7.97,7.97c.39.39.85.58,1.38.58,1.19,0,2-1.02,2-2,0-.52-.19-.99-.58-1.38l-4.62-4.62h15.65c1.1,0,2-.9,2-2s-.9-2-2-2Z"/></svg>
                                  </a>
                                }

                                {
                                  window.WorldApp && !worldAppWalletAddress &&
                                  <div className="pt-6 worldAppSignInDisplay">
                                    <h6 className="pb-1 fs-6 mb-0 opacity-50" style={{ color: props.text }} onClick={startEruda}>Complete checkout</h6>
                                    <p>To complete the checkout you need to sign in again with your World App wallet</p>
                                  </div>
                                }
                                {
                                  window.WorldApp && worldAppWalletAddress &&
                                  <h6 className="pt-md-1 pb-1 fs-6 mb-0 opacity-50" style={{ color: props.text }} onClick={startEruda}>Confirm payment</h6>
                                }
                                {
                                  !window.WorldApp &&
                                  <h6 className="pt-md-1 pb-1 fs-6 mb-0 opacity-50" style={{ color: props.text }}>Pay</h6>
                                }
                                
                                { window.WorldApp && worldAppWalletAddress &&
                                  <div className="worldAppPayRow">
                                    <div className="worldAppPayIcon">
                                      <div className="worldAppPayIconCircle">
                                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path fillRule="evenodd" clipRule="evenodd" d="M3.28995 5.46768H24.7114V22.5255H3.28995V5.46768ZM22.9263 15.2858V12.7073H18.166V15.2858H22.9263Z" fill="white"/>
                                        </svg>
                                      </div>
                                    </div>
                                    <div className="worldAppText">
                                      <div className="worldAppPayTitle">
                                        <h6>Pay</h6>
                                      </div>
                                      <div className="worldAppPaySubTitle">
                                        from Wallet
                                      </div>
                                    </div>
                                    <div className="worldAppPayAmount">
                                      <h5>{ new Currency({ amount: props.amount, code: props.currency }).toString() }</h5>
                                    </div>
                                  </div>
                                }
                                { !window.WorldApp &&
                                  <h5 className="fs-2 mb-0 fw-bold" style={{ color: props.text }}>{ new Currency({ amount: props.amount, code: props.currency }).toString() }</h5>
                                }

                              </div>
                            </div>
                          </div>
                          <div className='align-self-end w-100 d-none d-md-block pt-6'>
                            <div className='opacity-50' style={{ color: props.text }}>
                              <div className='d-block d-md-inline-block me-3'>
                                <small><span>Powered by</span><strong className='ms-1'><a href='https://depay.com' style={{ color: props.text }} target='_blank' title='DePay'>DePay</a></strong>
                                </small>
                              </div>
                              <div className='d-block d-md-inline-block'>
                                <a className='me-2' href='https://depay.com/web3-payments' style={{ color: props.text }} target='_blank'><small>Web3 Payments</small></a>
                                <a className='ms-1 me-2' href='https://depay.com/legal/terms' style={{ color: props.text }} target='_blank'><small>Terms</small></a>
                                <a className='ms-1 me-2' href='https://depay.com/privacy' style={{ color: props.text }} target='_blank'><small>Privacy</small></a>
                                <a className='ms-1 me-2' href='mailto:support@depay.com?subject=Problem with Shopify Payment 9788a65f-ba03-4fed-812e-d442ad928d9a' style={{ color: props.text }} target='_blank'><small>Help</small></a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-md-6 ps-0 ps-md-5 pt-md-2'>
                    <div className='container row pe-0 pe-md-5'>
                      <div className='col-5 payment-link-column right px-4 px-md-0 bg-grey pb-0 pt-4 pt-md-0'>
                        <div className='flex-grow-1 pt-3' style={{ minHeight: '45vh' }}>
                          <h2 className='h5 mb-0 pt-4'>Pay with crypto</h2>
                          <div className="pt-1 pb-3">
                            { [...new Set(props.accept.map((payment)=>payment.blockchain))].map((blockchain, index)=>{
                              return(
                                <img
                                  key={ index }
                                  className="rounded-1 me-1"
                                  title={ `Pay on ${Blockchains[blockchain].label}` }
                                  src={ Blockchains[blockchain].logo }
                                  style={{ boxShadow: 'rgba(0, 0, 0, 0.08) 0px 0px 4px', background: Blockchains[blockchain].logoBackgroundColor, width: '28px', height: '28px', padding: '1px' }}
                                />
                              )
                            }) }
                          </div>
                          <div className="pt-2">
                            { !window.WorldApp &&
                              <button type="button" onClick={ openPaymentWidget } className="btn rounded-2 btn-lg py-2 btn-primary w-100" style={{ background: props.color, borderColor: props.color }}>
                                <div className="py-1 w-100" style={{ color: props.text }}>
                                  Pay
                                </div>
                              </button>
                            }
                            { window.WorldApp && worldAppWalletAddress &&
                              <button type="button" onClick={ openPaymentWidget } className="btn rounded-2 btn-lg py-2 btn-primary w-100" style={{ background: props.color, borderColor: props.color }}>
                                <div className="py-1 w-100" style={{ color: props.text }}>
                                  Pay
                                </div>
                              </button>
                            }
                            { window.WorldApp && !worldAppWalletAddress &&
                              <button type="button" onClick={ ()=>{ (new wallets.WorldApp()).connect().then((address)=>setWorldAppWalletAddress(address)) } } className="btn rounded-2 btn-lg py-2 btn-primary w-100">
                                <div className="py-1 w-100">
                                  Sign in
                                </div>
                              </button>
                            }
                          </div>
                        </div>
                        <div className='align-self-end w-100 d-block d-md-none pt-5 pb-3 text-center pt-6'>
                          <div className='opacity-50'>
                            <div className='d-block d-md-inline-block me-3'>
                              <small><span>Powered by</span><strong className='ms-1'><a className='text-black' href='https://depay.com' target='_blank' title='DePay'>DePay</a></strong></small>
                            </div>
                            <div className='d-block d-md-inline-block'>
                              <span className='opacity-50 ms-2 me-1 d-none d-md-inline-block'> | </span>
                              <a className='me-2 text-black' href='https://depay.com/web3-payments' target='_blank'>
                              <small>
                              Web3 Payments
                              </small>
                              </a>
                              <a className='ms-1 me-2 text-black' href='https://depay.com/legal/terms' target='_blank'>
                              <small>
                              Terms
                              </small>
                              </a>
                              <a className='ms-1 me-2 text-black' href='https://depay.com/privacy' target='_blank'>
                              <small>
                              Privacy
                              </small>
                              </a><a className='ms-1 me-2 text-black' href='mailto:support@depay.com?subject=Problem with Shopify Payment 9788a65f-ba03-4fed-812e-d442ad928d9a' target='_blank'><small>Help</small></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
